// libs
import { PAGE_TYPE, EVENTS } from 'shared/helpers/DTM';

// helpers
import NFA from 'shared/helpers/analytics/NFAnalytics';

// constants
import { TRACK_TYPE } from 'shared/helpers/analytics/constants';
import { WISHLIST_EVENTS } from 'shared/helpers/analytics/constants/wishlist';

// constants declarations
const CHANNEL = 'NDS';

interface IOnPageLoad {
  totalCount: number;
  products: Listing.IProduct[];
  isPriceDropStrip?: boolean;
  isPriceRevealEnabled: boolean;
  isSalePriceLiveEnabled: boolean;
}

const getCommaSeperatedString = (array: (number | string)[]) => {
  if (array.length > 0) {
    return array.join(',');
  }
  return '';
};

const getProductsListData = (
  products: Listing.IProduct[],
  isPriceRevealEnabled: boolean,
  isSalePriceLiveEnabled: boolean
) => {
  try {
    let brandNameList: string[] = [];
    let productIdList: string[] = [];
    let productNameList: string[] = [];
    let wishlistProductsOOSCount = 0;

    products.forEach((product) => {
      brandNameList.push(product?.brandName[0]);
      productIdList.push(product?.id);
      productNameList.push(product?.name);
      wishlistProductsOOSCount += product.inStock ? 0 : 1;
    });

    const isSalePriceLive = products.some(
      (product) =>
        isPriceRevealEnabled && isSalePriceLiveEnabled && product.inStock && !product.priceRevealDTO
    );

    return {
      brandNameList: getCommaSeperatedString(brandNameList),
      productIdList: getCommaSeperatedString(productIdList),
      productNameList: getCommaSeperatedString(productNameList),
      wishlistProductsOOSCount,
      isOffersAvailable: 'NA',
      isCouponsAvailable: 'NA',
      isSalePriceLive,
    };
  } catch (err) {
    return {};
  }
};

export const getPageloadData = ({
  products,
  totalCount,
  isPriceDropStrip,
  isPriceRevealEnabled,
  isSalePriceLiveEnabled,
}: IOnPageLoad) => {
  return {
    totalCount,
    wishlistProductCount: totalCount,
    isPriceDropStrip,
    ...getProductsListData(products, isPriceRevealEnabled, isSalePriceLiveEnabled),
  };
};

export const onPageLoad = ({
  products,
  totalCount,
  isPriceDropStrip,
  isPriceRevealEnabled,
  isSalePriceLiveEnabled,
}: IOnPageLoad) => {
  const data: { [key: string]: string | number } = {};
  data.pagename = `${CHANNEL} : wishlist`;
  data.eventName = EVENTS.WISHLIST;
  data.pagetype = PAGE_TYPE.WISHLIST;
  data.totalProductsInWishlist = totalCount;

  // todo mp: remove after omniture removal
  // DTM.onPageLoad(data);

  const pageData = getPageloadData({
    products,
    totalCount,
    isPriceDropStrip,
    isPriceRevealEnabled,
    isSalePriceLiveEnabled,
  });

  NFA.track({
    type: TRACK_TYPE.PAGELOAD,
    event: WISHLIST_EVENTS.PAGELOAD,
    data: pageData,
    dtmData: data,
  });
};
